import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  // eslint-disable-next-line
  selector: 'input[integerOnly]',
})
export class IntegerOnlyDirective {

  private allowedRegex = /^[0-9]*$/;

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '-'
    ];

    // Allow navigation keys
    if (allowedKeys.includes(event.key)) return;

    // Block decimal separators
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
      return;
    }

    // Block any non-number key
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') || '';

    // Reject if pasted content contains non-integer chars
    if (!this.allowedRegex.test(pasted)) {
      event.preventDefault();
    }
  }
}
